import App from './app'

document.addEventListener('DOMContentLoaded', (event) => {

	new App()

})
